import { render, staticRenderFns } from "./ProjectInfos.vue?vue&type=template&id=194ca888&scoped=true&"
import script from "./ProjectInfos.vue?vue&type=script&lang=js&"
export * from "./ProjectInfos.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfos.vue?vue&type=style&index=0&id=194ca888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194ca888",
  null
  
)

export default component.exports